import React, { useState, useEffect } from 'react';
import SettingIcon from 'assets/icon/SettingIcon';
import NotepadIcon from 'assets/icon/NotepadIcon';
import DashboardIcon from 'assets/icon/DashboardIcon';
import GroupIcon from 'assets/icon/GroupIcon';
import MapPinIcon from 'assets/icon/MapPinIcon';
import KeyIcon from 'assets/icon/KeyIcon';
import TimeFiveIcon from 'assets/icon/TimeFiveIcon';

export default function Sidebar({ isOpen, onSidebarClick, menuAccess }) {
	const [isSidebarHome, setIsSidebarHome] = useState(true)
	const [isAdmin, setIsAdmin] = useState("0")

	let pathArray = window.location.pathname.split("/")
	
	useEffect(() => {
		setIsAdmin(localStorage.getItem("IsAdmin"))
	}, [])
  
	return (
		<div className={`fixed sm:relative h-screen bg-white shadow-md transition-all z-20 ${ isOpen ? 'w-full sm:w-64' : 'hidden sm:block sm:w-20' } `}>
			<div className={`h-screen flex flex-col items-center gap-6 lg:text-base py-4 w-full`}>
				<div className="items-start flex flex-col w-full gap-2 px-4 overflow-y-auto">
					<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/' ? 'bg-black text-white fill-white' : '' } 
							${ isOpen ? 'px-4' : 'justify-center px-2' } 
						`}
						onClick={onSidebarClick}
						href="/"
					>
						<DashboardIcon className='w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Dashboard</p>
					</a>
					<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname.includes('/sales') ? 'bg-black text-white fill-white' : '' }
							${ isOpen ? 'px-4' : 'justify-center px-2' }
						`}
						onClick={onSidebarClick}
						href="/sales"
					>
						<NotepadIcon className='w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Sales</p>
					</a>
					<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname.includes('/report') ? 'bg-black text-white fill-white' : '' }
							${ isOpen ? 'px-4' : 'justify-center px-2' }
						`}
						onClick={onSidebarClick}
						href="/report"
					>
						<NotepadIcon className='w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Report</p>
					</a>
					<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname.includes('/session') ? 'bg-black text-white fill-white' : '' }
							${ isOpen ? 'px-4' : 'justify-center px-2' }
						`}
						onClick={onSidebarClick}
						href="/session"
					>
						<TimeFiveIcon className='w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Session</p>
					</a>

					<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname.includes('/location') ? 'bg-black text-white fill-white' : '' }
							${ isOpen ? 'px-4' : 'justify-center px-2' }
							${ isAdmin === '1' ? '' : 'hidden' }
						`}
						onClick={onSidebarClick}
						href="/location"
					>
						<MapPinIcon className='w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Location</p>
					</a>
					<a
						className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname.includes('/employee') ? 'bg-black text-white fill-white' : '' } 
							${ isOpen ? 'px-4' : 'justify-center px-2' }
							${ isAdmin === '1' ? '' : 'hidden' }
						`}
						onClick={onSidebarClick}
						href="/employee"
					>
						<GroupIcon className='w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Employee</p>
					</a>
					<a
						className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md items-center hidden
							${ window.location.pathname.includes('/employee-access') ? 'bg-black text-white fill-white' : '' } 
							${ isOpen ? 'px-4' : 'justify-center px-2' }
							${ isAdmin === '1' ? '' : 'hidden' }
						`}
						onClick={onSidebarClick}
						href="/employee-access"
					>
						<KeyIcon className='w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Employee Access</p>
					</a>
					<a
						className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname.includes('/setting') ? 'bg-black text-white fill-white' : '' } 
							${ isOpen ? 'px-4' : 'justify-center px-2' }
							${ isAdmin === '1' ? '' : 'hidden' }
						`}
						onClick={onSidebarClick}
						href="/setting"
					>
						<SettingIcon className='w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Setting</p>
					</a>
				</div>
			</div>	
		</div>
  	)
}
